// components/GlobalSnackbar.js
import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useDispatch, useSelector } from "react-redux";
import { hideSnackbar, resetSnackbarStyles } from "../../Store/Slices/snackbarSlice";

export default function GlobalSnackbar() {
    const dispatch = useDispatch();
    const { open, message, severity, styles, position } = useSelector((state) => state.snackbar);

    const handleClose = (_, reason) => {
        // if (reason === "clickaway") return;
        dispatch(hideSnackbar());
        setTimeout(() => {
            dispatch(resetSnackbarStyles());
        }, 100);
    };

    return (
        <Snackbar
            open={open}
            autoHideDuration={2000}
            onClose={handleClose}
            anchorOrigin={position}
            sx={styles}
        >
            <Alert
                onClose={handleClose}
                severity={severity}
                variant="filled"
                sx={{ width: "100%" }}
            >
                {message}
            </Alert>
        </Snackbar>
    );
}
